import {ApiBase} from "./ApiBase";
import {IApiResult} from "./AxiosWealthManagementApi";

export class CashFlowsApi {
    public static uploadCashFlows(formData: FormData): Promise<IApiResult<boolean>> {
        return ApiBase.processPost("/cash-flow", formData);
    }
}
